<template lang="html">
    <div class="login-index">
        <div class="fd-banner">
            <h3></h3>
            <div class="fd-title">
                <div class="fd-title-inner">
                    <div class="title-content">
                        <h3>Hi, 您好</h3>
                        <div>
                            <span>
                                欢迎登录在线服务保全系统
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="login-content">
                <iframe
                        class="login-box"
                        frameborder="0"
                        :src="aliUrl"
                >
                </iframe>
        </div>
    </div>
</template>

<script>
    import {setToken} from '@/utils/auth';

    export default {
        data() {
            return {
                aliUrl: ''
            }
        },
        methods: {
            clearUselessKey: function () {
                // 访问登录页面清除token, 防止请求不需要权限的接口报错
                setToken(null);
                // 清除当前担保id
                sessionStorage.removeItem("currentDbid");
                // 清除当前保全id
                sessionStorage.removeItem("currentBqid");
            },
            // addAliLoginListener: function () {
            //     this.$axios.get("/account/api/account/refres?type=1")
            //         .then(res => {
            //             let param = res.data;
            //             let aliUrl = process.env.VUE_APP_ALI_BASE_URL_PRO + "/oauth/authorize?deviceType=H5&" + param;
            //             this.aliUrl = aliUrl;
            //             console.log("阿里", aliUrl);
            //         });
            //     window.addEventListener('message', (e) => {
            //         let res = {
            //             message: ''
            //         };
            //         try {
            //             res = JSON.parse(e.data)
            //         } catch (e) {
            //             console.log(e);
            //         }
            //         //消息类型
            //         if (res.message == '获取令牌成功') {
            //             if (res.data.cUserid) {
            //                 setToken(res.data.token);
            //                 this.$notify({
            //                     type: 'success',
            //                     message: '登录成功'
            //                 });
            //                 this.$router.push("/");
            //             } else {
            //                 // this.$store.dispatch('SetAccountInfoIsShow', true)
            //                 console.log("获取令牌好像失败了");
            //             }
            //         }
            //     })
            // },
        },
        created() {
            this.clearUselessKey();
           // this.addAliLoginListener();
        }
    }
</script>

<style lang="less" scoped>
    .login-index {
        overflow-y:hidden;
        width: 100%;
        height: 100%;
        background: #f3f3f3;

        .fd-banner {
            width: 100%;
            height: 51%;
            background: url('../../assets/image/icon-head.png') no-repeat center center;
            position: absolute;

            > h3 {
                font-size: 18px;
                color: #fff;
                text-align: left;
                padding-top: 30px/2;
            }

            .fd-title {
                padding-top: 40px;
                padding-bottom: 76px/2;
                color: #fff;

                .fd-title-inner {
                    width: 94%;
                    margin-left: 10%;
                    display: flex;

                    .title-logo {
                        width: 90px/2;
                        height: 104px/2;
                        margin-top: 6px;
                    }
                }
            }
        }

        .login-content {
            width: 90%;
            height: 380px;
            margin-left: 5%;
            position: relative;
            background: #fff;
            top: 140px;
        }
        .login-box{
            width: 100%;
            height: 100%;
        }

        #login-field-title {
            width: 90%;
            margin-left: 5%;
            color: #0683fc;
            padding: 20px 0;
            font-size: 24px;
        }

        .field-title {
            width: 90%;
            color: #666666;
            font-family: "Microsoft YaHei";
        }

        .title-content {
            text-align: left;

            > h3 {
                font-size: 22px;
            }

            > div {
                font-size: 24px;
                margin-top: 8px;
                letter-spacing: 2px;
            }
        }

        #get-password-back {
            width: 90%;
            color: #666666;
            font-family: "Microsoft YaHei";
            text-align: right;
        }

        #login-button {
            margin-top: 15px;
        }

        #register-class {
            width: 90%;
            color: #666666;
            font-family: "Microsoft YaHei";
            text-align: center;
            margin-top: 20px;
        }

        .fd-login-tit {
            color: #999999;
            margin-top: 10px;
            margin-left: 18px;
        }

        .fd-login-btn {
            width: 90%;
            margin-left: 5%;
        }

        .fd-register-btn {
            color: #0683fc;
        }

        .fd-refresh-icon {
            color: #0683fc;
            font-size: 26px;
            padding-left: 5px;
        }

        .fd-verification-code {
            display: flex;
        }
    }
</style>
